import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import React, { useState } from "react";
import { StyledCell, StyledRow } from "src/components/Common";
import useStyles from "src/views/conjuntos/useStyles";
import ResultadoSurvey from "../Resultados/ResultadoSurvey";
import DeleteEncuesta from "./DeleteEncuesta";
import ToggleEncuesta from "./ToggleEncuesta";

const TablaSurvey = ({ encuestas, conjunto, usuarios, tGlobal, tSurvey }) => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const columns = [
    { id: "nombre", label: tSurvey("survey_name") },
    { id: "activo", label: tGlobal("status") },
    { id: "respuestas", label: tSurvey("show_survey") },
    { id: "acciones", label: tGlobal("actions") },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer style={{ marginTop: "10px" }}>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <StyledCell
                key={col.id}
                align="center"
                style={col.id === "nombre" ? { width: "50%" } : {}}
              >
                {col.label}
              </StyledCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {encuestas
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <StyledRow key={row.id}>
                <StyledCell align="center">{row.title}</StyledCell>
                <StyledCell align="center">
                  <span
                    style={{
                      display: "inline-block",
                      padding: "2px 14px",
                      borderRadius: 15,
                      backgroundColor: row?.isActive ? "#43a047" : "#e53935",
                      color: "#fff",
                      minWidth: 90,
                    }}
                  >
                    {row?.isActive ? tGlobal("enabled") : tGlobal("disabled")}
                  </span>
                </StyledCell>
                <StyledCell align="center">
                  {row.loop} {tGlobal("days")}
                </StyledCell>
                <StyledCell align="center">
                  <ResultadoSurvey
                    encuesta={row}
                    conjunto={conjunto}
                    usuarios={usuarios}
                    tGlobal={tGlobal}
                    tSurvey={tSurvey}
                  />
                  <ToggleEncuesta
                    conjunto={conjunto}
                    encuesta={row}
                    encuestas={encuestas}
                    tGlobal={tGlobal}
                    tSurvey={tSurvey}
                  />
                  <DeleteEncuesta
                    conjunto={conjunto}
                    encuesta={row}
                    tGlobal={tGlobal}
                    tSurvey={tSurvey}
                  />
                </StyledCell>
              </StyledRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={encuestas.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
};

export default TablaSurvey;
